export default __webpack_public_path__ + "static/media/4.6d11f338.jpeg";